import type { ReactNode } from 'react';
import { lazy, Suspense } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@/component/Dialog';
import useTranslation from '@/feature/lang/hook';
import { ScrollToEnd } from './ScrollToEnd';

const AgreementContent = lazy(() => import('./AgreementContent'));

interface AgreementDialogProps {
  open: boolean;
  documentIds: string[];
  actions: ReactNode;
  onScrolledToEnd: () => void;
}

export const AgreementDialog = ({
  open = false,
  actions,
  documentIds,
  onScrolledToEnd,
}: AgreementDialogProps) => {
  const { texts } = useTranslation();

  return (
    <Dialog open={open} maxWidth="lg">
      <DialogTitle title={texts.auth.registration.agreements.message} />
      <DialogContent>
        <Suspense>
          <ScrollToEnd onScrolledToEnd={onScrolledToEnd}>
            <AgreementContent
              documentIds={documentIds}
              viewAcknowledgements
              forceExpanded
            />
          </ScrollToEnd>
        </Suspense>
      </DialogContent>
      <DialogActions right={actions}></DialogActions>
    </Dialog>
  );
};
